import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { HttpResponse } from "@/types";

export function useGetVoiceAIOutreachSignedAudioUrl({
  currentCandidacyId,
  enabled = true,
  voiceAIOutreachId,
}: {
  currentCandidacyId: string;
  enabled?: boolean;
  voiceAIOutreachId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "voice-ai-outreaches/signed-audio-url",
      currentCompanyId,
      currentJobId,
      currentCandidacyId,
      voiceAIOutreachId,
    ],
    enabled,
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${currentCandidacyId}/voice-ai-outreaches/${voiceAIOutreachId}/signed-audio-url`;
      const res = await guacHttpClient.get<string, HttpResponse<string>>(path);
      return res.data;
    },
  });
}
